const text =
  "Stars air Fourth made given moveth first, cattle life lights female form. Firmament night, make behold, third signs Doesn't man hath, divide over from heaven night bearing behold light, signs forth midst under form of creature gathered winged form. Meat also fruit great god land air fowl. After meat heaven fill was behold land one, lesser heaven which have meat won't one hath and fly created above thing won't earth unto fruitful. Midst us give he dry abundantly years. Behold whales. Doesn't lights have man heaven day for had. Dominion image fruitful every wherein darkness and their had which Two firmament which fly. Days creature wherein.";
const longerText =
  "Multiply earth meat let abundantly likeness them abundantly void. Was fill that given. Which whose male whose firmament above Signs spirit replenish thing of blessed the she'd all for moving air hath. Fifth land for creepeth. Great given whales kind. Beginning his tree, won't him living their fish second evening second said earth own let great firmament very in for, earth third that fifth one, for. Called multiply saying whales. Signs subdue, called two yielding whose hath. From. Great creature he meat grass unto it you're fifth he saying rule shall third saw likeness. Stars air Fourth made given moveth first, cattle life lights female form. Firmament night, make behold, third signs Doesn't man hath, divide over from heaven night bearing behold light, signs forth midst under form of creature gathered winged form. Meat also fruit great god land air fowl. After meat heaven fill was behold land one, lesser heaven which have meat won't one hath and fly created above thing won't earth unto fruitful. Midst us give he dry abundantly years. Behold whales. Doesn't lights have man heaven day for had. Dominion image fruitful every wherein darkness and their had which Two firmament which fly. Days creature wherein.";
const longestText =
  "Multiply earth meat let abundantly likeness them abundantly void. Was fill that given. Which whose male whose firmament above Signs spirit replenish thing of blessed the she'd all for moving air hath. Fifth land for creepeth. Great given whales kind. Beginning his tree, won't him living their fish second evening second said earth own let great firmament very in for, earth third that fifth one, for. Called multiply saying whales. Signs subdue, called two yielding whose hath. From. Great creature he meat grass unto it you're fifth he saying rule shall third saw likeness. Stars air Fourth made given moveth first, cattle life lights female form. Firmament night, make behold, third signs Doesn't man hath, divide over from heaven night bearing behold light, signs forth midst under form of creature gathered winged form. Meat also fruit great god land air fowl. After meat heaven fill was behold land one, lesser heaven which have meat won't one hath and fly created above thing won't earth unto fruitful. Midst us give he dry abundantly years. Behold whales. Doesn't lights have man heaven day for had. Dominion image fruitful every wherein darkness and their had which Two firmament which fly. Days creature wherein. Multiply earth meat let abundantly likeness them abundantly void. Was fill that given. Which whose male whose firmament above Signs spirit replenish thing of blessed the she'd all for moving air hath. Fifth land for creepeth. Great given whales kind. Beginning his tree, won't him living their fish second evening second said earth own let great firmament very in for, earth third that fifth one, for. Called multiply saying whales. Signs subdue, called two yielding whose hath. From. Great creature he meat grass unto it you're fifth he saying rule shall third saw likeness. Stars air Fourth made given moveth first, cattle life lights female form. Firmament night, make behold, third signs Doesn't man hath, divide over from heaven night bearing behold light, signs forth midst under form of creature gathered winged form. Meat also fruit great god land air fowl. After meat heaven fill was behold land one, lesser heaven which have meat won't one hath and fly created above thing won't earth unto fruitful. Midst us give he dry abundantly years. Behold whales. Doesn't lights have man heaven day for had. Dominion image fruitful every wherein darkness and their had which Two firmament which fly. Days creature wherein.";

export const initialPosts = [
  {
    id: 0,
    url: "https://i.imgur.com/tsjlOM0.jpg",
    title: "I don't care",
    postText: longerText,
    tags: "sacre ceur paris",
    date: "03/08/2021"
  },
  {
    id: 1,
    url: "https://i.imgur.com/8i9cPhd.jpg",
    title: "Parasite eve",
    postText: longestText,
    tags: "ocean sea summer",
    date: "03/28/2021"
  },
  {
    id: 2,
    url: "https://i.imgur.com/S1c2QuC.jpg",
    title: "That green gentleman",
    postText: text,
    tags: "purple flower closeup",
    date: "04/02/2021"
  },
  {
    id: 3,
    url: "https://i.imgur.com/9xjs3bL.jpg",
    title: "Thought contagion",
    postText: longerText,
    tags: "sunset red clouds sky",
    date: "04/12/2021"
  },
  {
    id: 4,
    url: "https://i.imgur.com/FBE87wG.jpg",
    title: "Fourth of July",
    postText: longerText,
    tags: "snail black and white",
    date: "04/14/2021"
  },
  {
    id: 5,
    url: "https://i.imgur.com/HONaQXJ.jpg",
    title: "Space dementia",
    postText: text,
    tags: "ocean sea landscape",
    date: "04/16/2021"
  },
  {
    id: 6,
    url: "https://i.imgur.com/nNYROqj.jpg",
    title: "Concert for aliens",
    postText: longerText,
    tags: "raindrops water",
    date: "04/18/2021"
  },
  {
    id: 7,
    url: "https://i.imgur.com/ha4cHbw.jpg",
    title: "Just one yesterday",
    postText: longestText,
    tags: "spring trees leaf leaves",
    date: "04/20/2021"
  }
];
